export enum AppModule {
  SIMA = 'SIMA',
  sales = 'sales',
  services = 'services',
  parts = 'parts',
  administration = 'administration',
  store = 'store',
  treasury = 'treasury',
  configuration = 'configuration'
}

export const moduleOrder: AppModule[] = [
  AppModule.SIMA,
  AppModule.sales,
  AppModule.services,
  AppModule.parts,
  AppModule.administration,
  AppModule.store,
  AppModule.treasury,
  AppModule.configuration
]

export interface ModuleConfig {
  nameKey: string
  descriptionKey: string
  icon: string
}

export const moduleConfigurations: Record<AppModule, ModuleConfig> = {
  [AppModule.SIMA]: {
    nameKey: 'Module.SIMA.Name',
    descriptionKey: 'Module.SIMA.Description',
    icon: 'mdi-table'
  },
  [AppModule.sales]: {
    nameKey: 'Module.sales.Name',
    descriptionKey: 'Module.sales.Description',
    icon: 'mdi-car-outline'
  },
  [AppModule.services]: {
    nameKey: 'Module.services.Name',
    descriptionKey: 'Module.services.Description',
    icon: 'mdi-wrench-outline'
  },
  [AppModule.parts]: {
    nameKey: 'Module.parts.Name',
    descriptionKey: 'Module.parts.Description',
    icon: 'mdi-puzzle-outline'
  },
  [AppModule.administration]: {
    nameKey: 'Module.administration.Name',
    descriptionKey: 'Module.administration.Description',
    icon: 'mdi-file-document-outline'
  },
  [AppModule.store]: {
    nameKey: 'Module.store.Name',
    descriptionKey: 'Module.store.Description',
    icon: 'mdi-store-outline'
  },
  [AppModule.treasury]: {
    nameKey: 'Module.treasury.Name',
    descriptionKey: 'Module.treasury.Description',
    icon: 'treasure-chest'
  },
  [AppModule.configuration]: {
    nameKey: 'Module.configuration.Name',
    descriptionKey: 'Module.configuration.Description',
    icon: 'mdi-cog-outline'
  }
}
